import axios from "axios";

const API_DESPACHO = import.meta.env.VITE_API_DESPACHO;

const ScheduleGarrisonService = {
    list: async (filters = {}) => axios.post(`${API_DESPACHO}/schedule-garrison/list`, filters).then(({data}) => data.data).catch((err) => { throw err }),
    formData: async () => axios.get(`${API_DESPACHO}/schedule-garrison`).then(({data}) => data).catch((err) => { throw err }),
    get: async (id) => axios.get(`${API_DESPACHO}/schedule-garrison/${id}`).then(({data}) => data).catch((err) => { throw err }),
    getActivities: async (id) => axios.get(`${API_DESPACHO}/schedule-garrison/getActivities/${id}`).then(({data}) => data).catch((err) => { throw err }),
    save: async (formData) => axios.post(`${API_DESPACHO}/schedule-garrison`, formData).then(({data}) => data).catch((err) => { throw err }),
    update: async (id, formData) => axios.post(`${API_DESPACHO}/schedule-garrison/${id}`, formData).then(({data}) => data).catch((err) => { throw err }),
    destroy: async (id) => axios.delete(`${API_DESPACHO}/schedule-garrison/${id}`).then(({data}) => data).catch((err) => { throw err }),
};

export default ScheduleGarrisonService;
